import type { IRogueI18N } from "../RogueTypes"

/**
 * This function will take strings (with variables wrapped in {}) and replace the variables.
 * The source can be either english (if locale = en, or no translation was found) or a language.
 */
export function replaceVars(string: string, args?: string | { [data: string]: any }) {
  // If there are no args, we can just pass back the original string
  if (!args || typeof args !== 'object' || !Object.keys(args).length) {
    return string
  }

  let retval = string
  Object.keys(args).forEach(arg => {
    try {
      if (arg.indexOf('.') === -1) {
        // For standard interpolations: __('{count} products in cart', {count: 5})
        retval = retval.replace(`{${arg}}`, (args?.[arg] || ''))
      } else {
        // For Object notation interpolations: __('Logged in as {person.name} ', {person: {name: 'Andrew'}})
        const [obj, key] = arg.split('.')
        retval = retval.replace(`{${arg}}`, (args?.[obj]?.[key] || ''))
      }
    } catch (e) {
      // keep going with other translations...
    }
  })

  return retval
}

export const BaseI18N: IRogueI18N = {
  enabled: false,
  translate: replaceVars,
  loadNamespace: () => undefined,
}
